

document.addEventListener("DOMContentLoaded", function() { 

    var swipers = document.getElementsByClassName('swiper-default');
    var swiper = [];
    for (let i = 0; i < swipers.length; i++) {
        var target = swipers.item(i);
        var target_id = target.getAttribute('data-slider-id');
		
        var target_slides_per_view = target.getAttribute('data-slides-per-view') ? target.getAttribute('data-slides-per-view') : "auto";
        var target_effect = target.getAttribute('data-effect') ? target.getAttribute('data-effect') : "";

        var target_container = target.getAttribute('data-container') ? " > *" : "";
        var target_grab_cursor = target.getAttribute('data-effect') == "flip" ? true : false;
        var target_animation_duration = (typeof target.getAttribute('data-duration') == "string" && target.getAttribute('data-duration').length) ? target.getAttribute('data-duration') : "6000";
		
        var target_vertical 	= target.hasAttribute('data-vertical') 		? true : false;
        var target_loop 		= target.hasAttribute('data-loop') 			? true : false;
        var target_pagination 	= target.hasAttribute('data-pagination') 	? true : false;
        var target_navigation 	= target.hasAttribute('data-navigation') 	? true : false;
        var target_autoplay 	= target.hasAttribute('data-autoplay') 		? true : false;
        var target_inverse 		= target.hasAttribute('data-inverse')		? true : false;

		var target_pagination_type = target.getAttribute('data-pagination-type') ? target.getAttribute('data-pagination-type') : null;


		swiper[i] = new Swiper("[data-slider-id='"+target_id+"']" + target_container, {
			slidesPerView: target_slides_per_view,
			
			...(target_effect ? { 
				effect: target_effect 
			} : {}),

			grabCursor: target_grab_cursor,
			
			...(target_autoplay ? { 
				autoplay: {
					delay: target_animation_duration,
					...(target_inverse ? { reverseDirection: target_inverse } : {}),
				}, 
			} : {}),

			...(target_vertical ? { 
				direction: "vertical"
			} : {}),

			...(target_loop ? { 
				loop: target_loop 
			} : {}),
			
			...(target_pagination ? { 
				pagination: {
					el: "[data-slider-id='"+target_id+"'] .swiper-pagination",
					...(target_pagination_type ? { type: target_pagination_type } : {}),
				},
			} : {}),
			
			...(target_navigation ? { 
				navigation: {
					nextEl: target_navigation ? "[data-slider-id='"+target_id+"'] .swiper-button-next" : null,
					prevEl: target_navigation ? "[data-slider-id='"+target_id+"'] .swiper-button-prev" : null,
				},
			} : {}),
		});

    }
	window.addEventListener('load', function() {
		let  url = window.location;
		var hash = url.hash;
		if (hash) {
			hash = hash.substring(1);
			var section = document.getElementById(hash);
			if (section) {
				section.click()
				var section = document.getElementById(hash);
				var navbarHeight = document.querySelector('nav.navbar').offsetHeight;
				if (document.body.classList.contains('admin-bar')) {
					navbarHeight = navbarHeight + parseInt(window.getComputedStyle(document.documentElement).getPropertyValue("margin-top"), 10); 
				}
		  
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
				var CalculatedScroll = {
					top: section.getBoundingClientRect().top + scrollTop - navbarHeight
				};
	
				window.scrollTo({
					top: CalculatedScroll.top,
					behavior: "smooth"
				});
			} else {
				if (document.body.classList.contains('admin-bar')) {
					alert('De hashtag (#) in je url is niet op de pagina te vinden');
					if (url.href.split("#").pop().includes("%20")) {
						alert("Dit komt omdat je hashtag spaties bevat. Vervang de spaties met streepjes.")
						alert(url.href.replace(url.hash, '') + url.hash.replace('%20', '-'))
					}
					if (/^\d/.test(hash)) {
						alert("Dit komt omdat je hashtag begint met een nummer begint. Schrijf het nummer volledig uit. Of herschrijf de titel.")
						alert(url.href.replace(url.hash, '') + '#Tien-SEO-tips')
						alert(url.href.replace(url.hash, '') + '#De-beste-10-SEO-tips')
					}
				}
			}
		} 
	})
});



(function($){
	$(document).ready(function() {


        jQuery(function ($) {
            $('input[type="file"]').change(function () {
                if ($(this).val()) {
                    error = false;

                    var filename = $(this).val().replace(/^.*[\\\/]/, '');

                    $(this).closest('.file-upload').find('.file-name').html(filename);

                    if (error) {
                        parent.addClass('error').prepend.after('<div class="alert alert-error">' + error + '</div>');
                    }
                }
            });
        });

		/** Slick Slider Gallery options */
		if( $( '.gallery .bf-slides' ).length ) {
			$( '.gallery .bf-slides' ).slick({
				autoplay: true,
				speed: 500,
				nextArrow: '<div class="slick-next"><i class="fas fa-angle-right"></i></div>',
				prevArrow: '<div class="slick-prev"><i class="fas fa-angle-left"></i></div>',
				dots: true,
				appendDots: '.gallery .slider-dots',
				/** Customizing the dots */
				customPaging: function( slider, i ) {
					return '<a href="#" class="dot-' + i + '"></a>';
				},
			});
		}

		/** Slick Slider CTP options */
		if( $( '.ctp .bf-slides' ).length ) {
			$( '.ctp .bf-slides' ).slick({
				autoplay: true,
				speed: 750,
				nextArrow: '<div class="slick-next"><i class="fas fa-chevron-right"></i></div>',
				prevArrow: '<div class="slick-prev"><i class="fas fa-chevron-left"></i></div>',
				dots: true,
				appendDots: '.ctp .slider-dots',
				appendArrows: '.ctp .slider-dots',
				/** Customizing the dots */
				// customPaging: function( slider, i ) {
				// 	return '<a href="#" class="dot-' + i + '"></a>';
				// },
			});
		}

		$('.bf-slides').on('setPosition', function () {
			ResizeSlider();
		});

		//we need to maintain a set height when a resize event occurs.
		//Some events will through a resize trigger: $(window).trigger('resize');
		$(window).on('resize', function(e) {
			ResizeSlider();
		});

		//since multiple events can trigger a slider adjustment, we will control that adjustment here
		function ResizeSlider(){
			if ($('.bf-slides').length) {
				$slickSlider = $('.bf-slides');
				$slickSlider.find('.slick-slide').height('auto');

				var slickTrack = $slickSlider.find('.slick-track');
				var slickTrackHeight = $(slickTrack).height();

				$slickSlider.find('.slick-slide').css('height', slickTrackHeight + 'px');
			}
		}


		/** Fancybox options */
		if( $( '[data-fancybox="gallery"]' ).length ) {
			$( '[data-fancybox="gallery"]' ).fancybox({
				buttons : [ 'zoom', 'slideShow', 'close' ],
				clickOutside : 'close',
				loop : true,
				mobile : {
					clickSlide : function( current, event ) {
						$.fancybox.close();
					}
				},
				transitionEffect : 'slide',
			});
		}

		var position = $(window).scrollTop();

		// should start at 0

		$(window).scroll(function() {
			var scroll = $(window).scrollTop();
			if(scroll > position && $(this).scrollTop() > 130) {
				$('#masthead').addClass("hidden");
			} else {
				$('#masthead').removeClass("hidden");
			}
			position = scroll;
		});

		var accordions=null;
		var containers=null;
		var slideDuration=300;
		var scrollDuration=200;
		var classNameShow='show';
		var classNameAccordion='.question-item';
		var classNameContainer='.answer';
		$(document).ready(function(){
			accordions=$(classNameAccordion);
			containers=$(classNameContainer);
			$(classNameContainer).hide();
			accordions.each(function(){
				var openedAccordions=accordions.filter(function(){return $(this).hasClass(classNameShow);});
				openedAccordions.removeClass(classNameShow);
				openedAccordions.next(classNameContainer).stop(true).slideDown({
					duration:slideDuration,
					complete:function(){openedAccordions.addClass(classNameShow);}
				});
			});
			accordions.click(function(){
				var currentAccordion=$(this);
				var currentContainer=$(this).next(classNameContainer);
				var openedAccordions=accordions.filter(function(){return $(this).hasClass(classNameShow);});
				if(!currentAccordion.hasClass(classNameShow)){
					currentContainer.stop(true).slideDown({
						duration:slideDuration,
						complete:function(){currentAccordion.addClass(classNameShow);}
					});
				}else{
					currentContainer.stop(true).slideUp({
						duration:slideDuration,
						complete:function(){currentAccordion.removeClass(classNameShow);}
					});
				}
				containers.not(currentContainer).stop(true).slideUp({
					duration:slideDuration,
					complete:function(){openedAccordions.removeClass(classNameShow);}
				});
			});
		});

	});
}(jQuery));
